import * as React from 'react';
import type { AllCMSPageFields } from '@/cms/fields/mappers/common';
import { PageFieldsContext } from '../context';

export const useCMSPageField = <K extends keyof AllCMSPageFields>(fieldName: K): AllCMSPageFields[K] => {
  const fields = React.useContext(PageFieldsContext);
  if (!fields) {
    throw new Error("Attempted to use 'useCMSPageField' before initializing PageFieldsProvider.");
  }

  return fields[fieldName];
};
